export const poiOne = (props) => {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g>
        <path d="M76.67,50.41c16.08,0,19.67-7.76,22.89-16.65h14V166.17H92.75v-101H76.67Z"/>
        <path d="M183.57,16.43V183.57H16.43V16.43H183.57M196.18,3.82H3.82V196.18H196.18V3.82Z"/>
      </g>
    </svg>
  )
}

export const poiTwo = (props) => {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g>
        <path d="M96.78,51.16c-6.62,0-10.78,3.6-10.78,13V78.4H66.33V65.54c0-21.19,10.59-33.29,31-33.29s31,12.1,31,33.29c0,17.59-6.43,31.78-25.72,52.39C90.35,131.17,87,137.41,87,144.41a14.28,14.28,0,0,0,.19,2.84h39.34v18.92H66.33V149.9c0-14.76,5.3-25.91,20.81-42.18C103,90.88,107.56,80.48,107.56,66.29,107.56,54.38,103.4,51.16,96.78,51.16Z"/>
        <path d="M183.57,16.43V183.57H16.43V16.43H183.57M196.18,3.82H3.82V196.18H196.18V3.82Z"/>
      </g>
    </svg>
  )
}

export const poiThree = (props) => {
  return (
    <svg viewBox="0 0 200 200"  {...props}>
      <g>
        <path d="M183.57,16.43V183.57H16.43V16.43H183.57M196.18,3.82H3.82V196.18H196.18V3.82Z"/>
        <path d="M68.41,135.15V124.37H88.08V136.1c0,9.46,4.17,13.05,10.79,13.05s10.78-3.22,10.78-14.94V123.42c0-12.29-4.16-16.83-13.62-16.83H89V87.67H96.6c7.75,0,12.48-3.4,12.48-14V64c0-9.46-4.35-13.24-10.4-13.24s-10,3.59-10,12.29v8.7H69v-7C69,43.6,79.57,31.87,99.43,31.87s30.46,11.54,30.46,32.72v4.73c0,14.19-4.54,22.89-14.76,26.68v.37c11.16,4.17,15.33,13.81,15.33,27.24v11.73c0,21.19-10.6,32.73-31,32.73S68.41,156.34,68.41,135.15Z"/>
      </g>
  </svg>
  )
}

export const alert = (props) => {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path d="M177.57,183H22.42a17.08,17.08,0,0,1-15-8.66,16.75,16.75,0,0,1,.11-17L85.09,25.5a17.35,17.35,0,0,1,29.82,0l77.57,131.83a16.73,16.73,0,0,1,.11,17,17.1,17.1,0,0,1-15,8.67ZM21.14,165.34a1,1,0,0,0,0,1.14,1.4,1.4,0,0,0,1.29.7H177.57a1.4,1.4,0,0,0,1.29-.71,1,1,0,0,0,0-1.13L101.28,33.51a1.39,1.39,0,0,0-2.57,0L21.14,165.34ZM100,127.66a7.9,7.9,0,0,1-7.91-7.9V80.24a7.91,7.91,0,0,1,15.81,0v39.52A7.9,7.9,0,0,1,100,127.66Zm0,23.71a8,8,0,0,1-3-.63,9.34,9.34,0,0,1-2.6-1.66,7.79,7.79,0,0,1-1.66-8.62,9.12,9.12,0,0,1,1.66-2.6A8.13,8.13,0,0,1,97,136.2a7.83,7.83,0,0,1,6,0,8.07,8.07,0,0,1,2.61,1.66,9.34,9.34,0,0,1,1.66,2.6,8,8,0,0,1,.63,3,7.82,7.82,0,0,1-7.9,7.9Z"/>
    </svg>
  )
}

export const danger = (props) => {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g>
        <path d="M169.88,140.75a125.12,125.12,0,0,0,11.71-55.57,81.63,81.63,0,0,0-163.18,0,125.12,125.12,0,0,0,11.71,55.57l-.46,1a16.5,16.5,0,0,0,2.89,18l11,12h0a16.78,16.78,0,0,0,12.22,5.36,15.9,15.9,0,0,0,4.6-.67L65.69,175l.79,1.39,1.18,5.69h0A13.33,13.33,0,0,0,79.08,192.5a163.67,163.67,0,0,0,41.84,0A13.31,13.31,0,0,0,132.3,182l1.17-5.69.84-1.38,5.35,1.55h0a15.42,15.42,0,0,0,4.52.67,16.76,16.76,0,0,0,12.22-5.36l11.09-12h0a16.72,16.72,0,0,0,2.84-18ZM164,144.64h0a9.74,9.74,0,0,1-1.67,10.42l-11,12a9.58,9.58,0,0,1-4.48,2.76,9.73,9.73,0,0,1-5.27,0l-10.38-3.18L127,173.59l-1.47,6.86a6.37,6.37,0,0,1-5.43,5.07,161.35,161.35,0,0,1-40.13,0,6.47,6.47,0,0,1-3.52-1.67,6.39,6.39,0,0,1-1.92-3.4l-1.42-6.86-4.19-6.94-10.41,3h0a9.65,9.65,0,0,1-9.71-2.76L37.66,155.06a9.54,9.54,0,0,1-2.39-5,9.64,9.64,0,0,1,.71-5.46l1.89-4.19h0A116.22,116.22,0,0,1,25.31,85.1a74.69,74.69,0,0,1,149.3,0,116.21,116.21,0,0,1-12.55,55.35Z"/>
        <path d="M102.3,145.72a2.51,2.51,0,0,0-4.64,0l-6,14.11A3.06,3.06,0,0,0,95.15,164a21.28,21.28,0,0,1,9.91,0,3.05,3.05,0,0,0,3.56-4.18Z"/>
        <path d="M78.41,102.88c-9.54-4.77-22,.92-27.87,12.55s-2.8,25.11,6.78,29.88,22.05-1,27.87-12.56S88,107.61,78.41,102.88Z"/>
        <path d="M121.55,102.88C112,107.61,109,121,114.81,132.75s18.29,17.49,27.87,12.56,12.55-18.12,6.74-29.88S131.13,98.11,121.55,102.88Z"/>
      </g>
    </svg>
  )
}

export const dot = (props) => {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <circle cx="100" cy="100" r="70"/>
    </svg>
  )
}

export const blockadeIcon = (props) => {
  return (
    <svg viewBox="0 -20 200 200" {...props}>
      <path d="M107,171.88a117.56,117.56,0,0,0-29.81-49,117.6,117.6,0,0,0-49-29.82L178.88,21.12Z"/>
      <path d="M164.73,35.27,107.65,154.91A129.18,129.18,0,0,0,45.09,92.36L164.73,35.27M193,7,7,95.74H7C56,100,100.05,144,104.26,193h0L193,7Z"/>
    </svg>
  )
}
